/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Container, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import { REACT_APP_API_APPROVE_CLAIM_REQUESTS, REACT_APP_API_FETCH_CLAIM_REQUESTS, REACT_APP_API_REJECT_CLAIM_REQUESTS } from "../../redux/apiConstants";
import Loader from '../../components/Loader/Loader';
import ClaimSubmittedCafeProfile from "./ClaimSubmittedCafeProfile";

const ViewClaimRequestPopup = React.memo(({ claimRequestId, handleClose, setIsUpdated,permission }) => {
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle, bodyheader, viewformStyle } =
    useContext(TableContext);
  const dispatch = useDispatch();
  const params = useParams();
  // let claimRequestId;
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [canDelete, setCanDelete] = useState(true);
  const {claimUpdate,setClaimUpdate} = useContext(TableContext);

  let statusCode;
  const getBankDetails = async () => {
    setLoading(true);
    axios
      .get(
        `${REACT_APP_API_FETCH_CLAIM_REQUESTS}/${claimRequestId}`,
        {
          method: "GET",
          headers: { Authorization: token },
        }
      )
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log("res.data.payout details", res.data.result);
          setDetails(res.data.result);
          setLoading(false);
        }else if (statusCode === 404) {
          console.log("no claim request.." );
          handleClose();
          setLoading(false);
        }else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    //   claimRequestId = params.id;
    getBankDetails();
    // setDashboardHeader("Payout Details");
  }, []);

  const handleApprove = (id, cafeId) => {
    console.log("approve id", cafeId);
    let data = {};

    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to approve?",
      buttons: canDelete
        ? [
          {
            label: "Yes",
            onClick: () => {
              const actionUrl = ` ${REACT_APP_API_FETCH_CLAIM_REQUESTS}/approve/${id} `;
              const actionData = { cafeId: cafeId };
              axios
                .post(actionUrl, actionData, {
                  headers: { Authorization: token },
                })
                .then((resp) => {
                  if (resp.status === 200) {
                    console.log("response-->", resp.data);
                    toast.success("Claim Request approved successfully");
                    handleClose();
                    setIsUpdated(true);
                  } else {
                    toast.error("Error approving Claim Request");
                  }
                })
                .catch((err) => {
                  toast.error("Error approving Claim Request");
                  console.error("Error: ", err);
                });
            },
          },
          {
            label: "No",
            // onClick: () => alert("Click No")
          },
        ]
        : [
          {
            label: "Ok",
            // onClick: () => alert("Click No")
          },
        ],
    });
  };

  const handleReject = (id, cafeId) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sur, you want to reject?",
      buttons: canDelete
        ? [
          {
            label: "Yes",
            onClick: () => {
              const actionUrl = ` ${REACT_APP_API_FETCH_CLAIM_REQUESTS}/reject/${id} `;
              const actionData = { cafeId: cafeId };
              axios
                .post(actionUrl, actionData, {
                  headers: { Authorization: token },
                })
                .then((resp) => {
                  if (resp.status === 200) {
                    console.log("response-->", resp.data);
                    toast.success("Claim Request rejected successfully");
                    handleClose();
                    setIsUpdated(true);  
                  } else {
                    toast.error("Error rejecting Claim Request");
                  }
                })
                .catch((err) => {
                  toast.error("Error rejecting Claim Request");
                  console.error("Error: ", err);
                });
            },
          },
          {
            label: "No",
            // onClick: () => alert("Click No")
          },
        ]
        : [
          {
            label: "Ok",
            // onClick: () => alert("Click No")
          },
        ],
    });
  };

  console.log("details---", details)
  return (
    <div className={styles.popupbox}>
      <div className={styles[formthemeStyle]} id={styles.box}>
        <span
          className={styles.closeicon}
          role="button"
          tabIndex={0}
          onClick={handleClose}
          onKeyPress={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>
        {loading ? (
          <Loader centered />
        ) : (
          <Container fluid>
            {/* <FontAwesomeIcon
                icon={faArrowLeft}
                value="Back"
                onClick={() => {
                  navigate(-1);
                }}
                className={styles.arrowback}
              /> */}
            <Row>
              <h5 className={styles[bodyheader]} id={styles.addheading}>
                Claim Request Details
              </h5>
              {/* <Col lg={12}>
                <div className={styles.profilepicdiv}>
                  {details.image ? (
                    <Image
                      src={details.image}
                      alt="logo"
                      className={styles.profilepic}
                    />
                  ) : (
                    <div style={{ minHeight: "20px" }}></div>
                  )}
                </div>
              </Col> */}
            </Row>
            {/* Cafe Information */}
            <Row className="mt-3">
              <Col lg={12}>
                <h6 className={styles[bodyheader]}>Cafe Information</h6>
                <div className={styles.detaildiv}>
                  <Row>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Cafe Name</span>
                        <p className={styles.empname}>{details?.cafe?.name || "N/A"}</p>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Address</span>
                        <p className={styles.empname}>{details?.cafe?.address || "N/A"}</p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Total Claims</span>
                        <p className={styles.empname}>{details?.totalClaims || 0}</p>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Pending Claims</span>
                        <p className={styles.empname}>{details?.pendingClaims || 0}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* Claims List */}
            {details?.claims && details.claims.length > 0 && (
              <Row className="mt-3">
                <Col lg={12}>
                  <h6 className={styles[bodyheader]}>Claim Requests</h6>
                  {details.claims.map((claim, index) => (
                    <div key={claim._id || index} className={styles.detaildiv} style={{ marginBottom: "20px", border: "1px solid #ddd", padding: "15px", borderRadius: "8px" }}>
                      {/* Vendor Info */}
                      <Row>
                        <Col lg={12}>
                          <h6 style={{ color: "#39979d", marginBottom: "10px" }}>
                            Vendor #{index + 1}
                            <span style={{ 
                              marginLeft: "10px", 
                              padding: "4px 10px", 
                              borderRadius: "4px", 
                              fontSize: "12px",
                              backgroundColor: claim.status === "Pending" ? "#ffc107" : claim.status === "Contested" ? "#ff9800" : claim.status === "Approved" ? "#28a745" : "#dc3545",
                              color: "#fff"
                            }}>
                              {claim.status}
                            </span>
                          </h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Vendor Name</span>
                            <p className={styles.empname}>{claim.vendor?.name || "N/A"}</p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Email</span>
                            <p className={styles.empname}>{claim.vendor?.email || "N/A"}</p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Phone</span>
                            <p className={styles.empname}>{claim.vendor?.phone || "N/A"}</p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Role</span>
                            <p className={styles.empname}>{claim.vendorRole || "N/A"}</p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Submitted</span>
                            <p className={styles.empname}>
                              {DateFormatter(claim.submittedAt, "MonthDayYear") || "N/A"}
                            </p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Referral Source</span>
                            <p className={styles.empname}>{claim.vendorReferralSource || "N/A"}</p>
                          </div>
                        </Col>
                      </Row>

                      {/* Business Details */}
                      <Row className="mt-2">
                        <Col lg={12}>
                          <h6 style={{ color: "#39979d", fontSize: "14px" }}>Business Details</h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Cafe Phone</span>
                            <p className={styles.empname}>{claim.cafePhone || "N/A"}</p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Business Type</span>
                            <p className={styles.empname}>{claim.businessType || "N/A"}</p>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Roaster Type</span>
                            <p className={styles.empname}>{claim.roasterType || "N/A"}</p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Roaster Names</span>
                            <p className={styles.empname}>{claim.roasterNames || "N/A"}</p>
                          </div>
                        </Col>
                      </Row>

                      <ClaimSubmittedCafeProfile
                        claim={claim}
                        styles={styles}
                        viewformStyle={viewformStyle}
                        empdivId={styles.empdiv}
                      />

                      {/* Documents */}
                      <Row className="mt-2">
                        <Col lg={12}>
                          <h6 style={{ color: "#39979d", fontSize: "14px" }}>Documents</h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Ownership Document</span>
                            {claim.ownershipDocumentUrl ? (
                              <Button
                                size="sm"
                                variant="outline-primary"
                                onClick={() => window.open(claim.ownershipDocumentUrl, "_blank")}
                              >
                                View Document
                              </Button>
                            ) : claim.healthPermitUrl ? (
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                onClick={() => window.open(claim.healthPermitUrl, "_blank")}
                              >
                                View legacy health permit
                              </Button>
                            ) : (
                              <p className={styles.empname}>Not Uploaded</p>
                            )}
                          </div>
                        </Col>
                      </Row>

                      {(claim.agreementAccepted || claim.insuranceUrl) && (
                      <>
                      <Row className="mt-2">
                        <Col lg={12}>
                          <h6 style={{ color: "#39979d", fontSize: "14px" }}>Legacy claim data</h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className={styles[viewformStyle]} id={styles.empdiv}>
                            <span className={styles.title}>Agreement Accepted</span>
                            <p className={styles.empname}>
                              {claim.agreementAccepted ? "Yes" : "No"}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      </>
                      )}

                      {/* Claim Notes */}
                      {claim.claimNotes && (
                        <Row className="mt-2">
                          <Col lg={12}>
                            <div className={styles[viewformStyle]} id={styles.empdiv}>
                              <span className={styles.title}>Claim Notes</span>
                              <p className={styles.empname}>{claim.claimNotes}</p>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {/* Action Buttons */}
                      {permission && (claim.status === "Pending" || claim.status === "Contested") && (
                        <Row className="mt-3">
                          <Col lg={12}>
                            <Button
                              className="btn-success mx-2"
                              onClick={() => handleApprove(claim.vendor?.id || claim.vendor?._id, details?.cafe?._id)}
                            >
                              <i className="fa fa-check" style={{ marginRight: "5px" }} />
                              Approve
                            </Button>
                            <Button
                              className="btn-danger"
                              onClick={() => handleReject(claim.vendor?.id || claim.vendor?._id, details?.cafe?._id)}
                            >
                              <i className="fa fa-times" style={{ marginRight: "5px" }} />
                              Reject
                            </Button>
                          </Col>
                        </Row>
                      )}
                    </div>
                  ))}
                </Col>
              </Row>
            )}
            {/* {!details?.adminApproved && details.payoutStatus !== "Rejected" && (
              <Row>
                <Col lg={4}>
                  <div id={styles.empdiv}>
                    <Button
                      className={`${styles.title} btn-success`}
                      onClick={() => {
                        handleApprove(details?.claimRequests?.[0]?.userId?.id, details?.id);
                      }}
                    >
                      Accept
                    </Button>
                  </div>
                </Col>
                <Col lg={4}>
                  <div id={styles.empdiv}>
                    <Button
                      className={`${styles.title} btn-danger`}
                      onClick={() => {
                        handleReject(details?.claimRequests?.[0]?.userId?.id, details?.id);
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                </Col>
              </Row>
            )} */}
          </Container>
        )}
      </div>
    </div>
  );
});

export default ViewClaimRequestPopup;
